{
  "addresses": [
    {
      "street": "Smörgatan 42",
      "zip": "412 76",
      "city": "Göteborg"
    },
    {
      "street": "Gamlestadsvägen 18A",
      "zip": "415 02",
      "city": "Göteborg"
    },
    {
      "street": "Haga Nygata 16, A",
      "zip": "413 01",
      "city": "Göteborg"
    },
    {
      "street": "Fyrmästargången 6",
      "zip": "413 18",
      "city": "Göteborg"
    }
  ]
}